import type {Color} from "@cm/graph-v3"
import {color} from "@cm/graph-v3"
import {z} from "zod/v4-mini"
import * as legacyZod from "zod"

export type Vec2 = {x: number; y: number}
export const vec2 = z.object({x: z.number(), y: z.number()})
export const legacyVec2 = legacyZod.object({x: legacyZod.number(), y: legacyZod.number()})

export type Vec3 = {x: number; y: number; z: number}
export const vec3 = z.object({x: z.number(), y: z.number(), z: z.number()})
export const legacyVec3 = legacyZod.object({x: legacyZod.number(), y: legacyZod.number(), z: legacyZod.number()})

export type Vec4 = {x: number; y: number; z: number; w: number}
export const vec4 = z.object({x: z.number(), y: z.number(), z: z.number(), w: z.number()})

export const isVec2 = (value: unknown): value is Vec2 => vec2.safeParse(value).success
export const isVec3 = (value: unknown): value is Vec3 => vec3.safeParse(value).success
export const isVec4 = (value: unknown): value is Vec4 => vec4.safeParse(value).success
export const isColor = (value: unknown): value is Color => color.safeParse(value).success
